<template>
  <page>
    <v-container fluid id="roleList" v-show="mode=='list'">
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 lg12 md12>
            <v-card>
              <v-card-title>
                <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.prevent="doExportList">
                  Export To Excel
                  <v-icon right>mdi-file-export</v-icon>
                </v-btn>
                <v-btn class="mx-2" color="primary" @click.prevent="openRolePage({ })" v-if="checkAccess([permissionKeys.perm_092005])">
                  New Role & Permission
                  <v-icon right>mdi-account-plus</v-icon>
                </v-btn>
              </v-card-title>
              <!-- <v-data-table
                v-model="selectedRole"
                :items="roles"
                :headers="tableHeaders"
                :search="search"
                :custom-filter="customSearch"
                :loading="loadingRoles">
                <template v-slot:item="row">
                  <td>{{row.item.label}}</td>
                  <td class="text-right">
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="red" v-on="on" @click="doPromptRemove(row.item)" class="tableActionBtn"  v-if="checkAccess([permissionKeys.perm_092015])">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="blue" v-on="on" @click="openRolePage(row.item)" class="tableActionBtn" v-if="checkAccess([permissionKeys.perm_092010])">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Review</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="teal" v-on="on" @click="openCopy(row.item)" class="tableActionBtn"  v-if="checkAccess([permissionKeys.perm_092020])">
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                      <slot></slot>
                    </div>
                  </td>
                </template>
              </v-data-table> -->
              <v-data-table
              :headers="tableHeaders"
              :items="roles"
              :loading="loadingRoles"
              :search="search"
              v-model="selectedRole"
              >
              <template v-slot:item="row">
                <tr>
                  <td>{{row.item.label}}</td>
                  <td class="text-sm-right text-md-right">
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="red" v-on="on" @click="doPromptRemove(row.item)" class="tableActionBtn"  v-if="checkAccess([permissionKeys.perm_092015])">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="blue" v-on="on" @click="openRolePage(row.item)" class="tableActionBtn" v-if="checkAccess([permissionKeys.perm_092010])">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Review</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn text icon color="teal" v-on="on" @click="openCopy(row.item)" class="tableActionBtn"  v-if="checkAccess([permissionKeys.perm_092020])">
                            <v-icon>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                      <slot></slot>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-slide-y-reverse-transition>
      <v-container fluid grid-list-lg v-show="mode !== 'list'" id="roleForm">
        <v-card :loading="loadingRoleDetail">
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 lg5 md5>
                <v-text-field :label="labels.description" v-model="role.description" :error-messages="errors.collect('description')"></v-text-field>
              </v-flex>
              <v-flex xs10 lg5 md5>
                <v-autocomplete v-model="role.roleLvl" :items="roleLvlList" :label="labels.roleLvl" item-text="label" item-value="value"
                data-vv-name="roleLvl" :data-vv-as="labels.roleLvl" :error-messages="errors.collect('roleLvl')" v-validate="'required'" clearable></v-autocomplete>
              </v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                </template>
                <span>{{ labels.roleLvlTip }}</span>
              </v-tooltip>
              <v-flex xs12 lg5 md5>
                <v-autocomplete v-model="role.modId" :items="modIdList" :label="labels.modId" item-text="label" item-value="value"
                data-vv-name="modId" :data-vv-as="labels.modId" :error-messages="errors.collect('modId')" v-validate="'required'" clearable></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-account-key</v-icon>
            <v-toolbar-title>Permissions</v-toolbar-title>
          </v-toolbar>
          <v-layout>
            <v-flex>
              <v-card-text>
                <v-treeview
                  v-model="selectedPermissions"
                  :items="permissions"
                  activatable
                  active-class="grey lighten-5"
                  selected-color="green"
                  open-on-click
                  selectable
                  expand-icon="mdi-chevron-down"
                  on-icon="mdi-checkbox-marked"
                  off-icon="mdi-checkbox-blank-outline"
                  indeterminate-icon="mdi-checkbox-intermediate">
                </v-treeview>
              </v-card-text>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs12 md6>
              <v-card-text>
                <div v-if="selections.length === 0" key="title" class="title font-weight-light grey--text pa-3 text-xs-center">
                  Select your permissions
                </div>
                  <v-text-field v-if="selections.length !== 0" append-icon="mdi-magnify" label="Search Selected Permission" single-line hide-details v-model="search"></v-text-field>
                  <!-- <v-data-table v-if="selections.length !== 0"
                  v-bind:headers="listPermHeaders" v-bind:items="selections"
                  :server-items-length="totalPermItems" :footer-props="{'items-per-page-options': itemsPerPage }"
                  :search="search"
                  :custom-filter="customSearch"
                  v-bind:options.sync="paginationPerm" item-key="key" :loading="loading" :no-data-text="noDataText">
                     <template v-slot:item="row">
                      <td v-for="column in selectedPermColumns" :key="column">{{row.item[column]}}</td>
                    </template>
                  </v-data-table> -->
                  <v-data-table
                  :headers="listPermHeaders"
                  :items="selections"
                  :loading="loading"
                  :search="search"
                  item-key="key"
                  >
                </v-data-table>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-card-actions >
            <v-btn class="white--text error" @click.prevent="mode = 'list'">
              Cancel
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn class="white--text" color="primary" @click="saveRole" v-show="mode=='create'" :loading="processing">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
            <v-btn class="white--text" color="primary" @click="updateRole" v-show="mode=='update'" :loading="processing">
              Update
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="selectedPermissions = []">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-slide-y-reverse-transition>
    <confirm v-model="promptRemove" @ok="removeRole" title="Remove Role">
      Are you sure you want to remove role <b>{{roleForDelete.label}}</b>?
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { roleLvl, modId } from '@/const/common'
import { mapGetters } from 'vuex'
import { permissionKeys } from '@/mixins/global/permissionKey'
export default {
  data() {
    return {
      labels: {
        description: 'Role Name',
        roleLvl: 'Role Level',
        modId: 'Module ID',
        roleLvlTip: '1 is the lowest level (e.g. Data Entry) and 10 is the highest level (e.g. CEO)'
      },
      permissionKeys: permissionKeys,
      mode: 'list',
      loadingRoles: false,
      loadingRoleDetail: false,
      processing: false,
      promptRemove: false,
      selectedRole: undefined,
      roleForDelete: { description: '' },
      roles: [],
      tableHeaders: [
        { text: 'Role', align: 'left', sortable: true, value: 'label' },
        { text: 'Action', align: 'right', value: 'action', sortable: false }
      ],
      role: {
        description: undefined,
        roleLvl: undefined,
        modId: undefined
      },
      permissionMap: {},
      selectedPermissions: [],
      permissions: [],
      paginationPerm: {
        page: 1
      },
      totalPermItems: 0,
      selectedPermColumns: ['permKey', 'fieldType', 'description'],
      permColumns: [
        { text: 'Permission', value: 'permKey' },
        { text: 'Type', value: 'fieldType' },
        { text: 'Description', value: 'description' }
      ],
      roleItems: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listPermHeaders() {
      let result = []
      for (const selectedColumn of this.selectedPermColumns) {
        let findCol = this.permColumns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    },
    roleName() {
      if (this.roleForDelete) {
        return this.roleForDelete.description
      } else {
        return ''
      }
    },
    selections () {
      const selections = []
      if (this.selectedPermissions !== undefined) {
        for (const id of this.selectedPermissions) {
          const perm = this.permissionMap[id]
          if (!perm) continue
          if (perm.description !== undefined) {
            selections.push(perm)
          }
        }
      }
      return selections.sort((a, b) => {
        return a.id > b.id ? 1 : -1
      })
    },
    roleLvlList() {
      let result = []
      Object.keys(roleLvl).forEach(function(key) {
        const status = roleLvl[key]
        result.push({
          label: status,
          value: parseInt(key)
        })
      })
      return result
    },
    modIdList() {
      let result = []
      Object.keys(modId).forEach(function(key) {
        const status = modId[key]
        result.push({
          label: status,
          value: parseInt(key)
        })
      })
      return result
    }
  },
  watch: {
    'paginationPerm': function (value) {
      // this.fetchData()
    },
    'search': function (value) {
      this.roleItems = []
      this.roles.filter(data => {
        if (data.label.toLowerCase().includes(value.toLowerCase())) {
          this.roleItems.push(data.value)
        }
      })
    }
  },
  methods: {
    init() {
      this.fetchRoles()
    },
    async fetchRoles() {
      this.search = ''
      this.loadingRoles = true
      const apiURI = this.$store.state.adminUser.menu.roles
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.roles = data.data.roles
            this.menu = extractMenu(data._links)
            this.permissions = data.data.permissions
            this.fetchAllPerm()
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          this.$toast.error('Failed to retrieve roles list')
        }
      } else {
        this.$toast.error('Missing api URI (fetch roles)')
      }
      this.loadingRoles = false
    },
    async doExportList() {
      // OK-495
      this.loadingRoleDetail = true
      const apiURI = this.menu.exportRoleAccessAndPermissionListExcel
      if (apiURI) {
        try {
          const expand = {
            roleItems: this.roleItems.join()
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.loadingRoleDetail = false
            return data
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$toast.error('Missing api URI (fetch role detail)')
      }
      this.loadingRoleDetail = false
    },
    async openRolePage(role) {
      this.resetMessages()
      this.role.id = undefined
      this.role.description = ''
      this.role.roleLvl = 0
      this.role.modId = 0
      this.selectedPermissions = []
      if (role && role.value) {
        this.mode = 'update'
        const data = await this.fetchRoleDetail(role.value)
        this.role.id = data.roleId
        this.role.description = data.description
        this.role.roleLvl = data.roleLvl
        this.role.modId = data.modId
        this.selectedPermissions = data.permissions
      } else {
        this.mode = 'create'
      }
    },
    async openCopy(role) {
      this.resetMessages()
      this.role.description = ''
      this.role.roleLvl = 0
      this.role.modId = 0
      this.selectedPermissions = []
      if (role && role.value) {
        this.mode = 'create'
        const data = await this.fetchRoleDetail(role.value)
        this.role.id = undefined
        this.role.description = data.description + ' - Copy'
        this.selectedPermissions = data.permissions
        this.role.roleLvl = data.roleLvl
        this.role.modId = data.modId
      }
    },
    async fetchRoleDetail(roleId) {
      this.search = ''
      this.loadingRoleDetail = true
      const apiURI = this.menu.role
      if (apiURI) {
        try {
          const expand = { roleId: roleId }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.loadingRoleDetail = false
            return data
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$toast.error('Missing api URI (fetch role detail)')
      }
      this.loadingRoleDetail = false
    },
    async saveRole() {
      const apiURI = this.menu.addRole
      if (apiURI) {
        this.processing = true
        try {
          const expand = {
            id: this.role.id,
            description: this.role.description,
            roleLvl: this.role.roleLvl,
            modId: this.role.modId,
            permissions: this.selectedPermissions
          }
          const result = await this.$http.post(apiURI, expand)
          if (result && result.data) {
            this.mode = 'list'
            this.fetchRoles()
            this.notify(result.data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.fieldMessage(data)
          } else {
            this.$toast.error('Unexpected server response')
          }
        }
        this.processing = false
      } else {
        this.$toast.error('Missing api URI (saveRole)')
      }
    },
    async updateRole() {
      const apiURI = this.menu.updateRole
      if (apiURI) {
        this.processing = true
        try {
          const expand = {
            id: this.role.id
          }
          const roleData = {
            id: this.role.id,
            description: this.role.description,
            roleLvl: this.role.roleLvl,
            modId: this.role.modId,
            permissions: this.selectedPermissions
          }
          const result = await this.$http.patch(expandURI(apiURI, expand), roleData)
          if (result && result.data) {
            this.$toast.success('Record successfully saved.')
            this.mode = 'list'
            this.fetchRoles()
          }
        } catch (err) {
          this.notify(err.data)
        }
        this.processing = false
      } else {
        this.$toast.error('missing api URI (updateRole)')
      }
    },
    doPromptRemove(role) {
      this.roleForDelete = role
      this.promptRemove = true
    },
    async removeRole() {
      const apiURI = this.menu.deleteRole
      if (apiURI) {
        this.processing = true
        try {
          const expand = {
            id: this.roleForDelete.value
          }
          const result = await this.$http.delete(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.fetchRoles()
            this.notify(data)
          }
        } catch (err) {
          this.$toast.error(err.data)
        }
        this.processing = false
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fetchAllPerm() {
      for (var i = 0; i < this.permissions.length; i++) {
        const p = this.permissions[i]
        this.permissionMap[p.id] = p
        if (p.children && p.children.length) {
          this.fetchChildPerm(p.children)
        }
      }
    },
    fetchChildPerm(children) {
      for (var i = 0; i < children.length; i++) {
        const p = children[i]
        this.permissionMap[p.id] = p
        if (p.children && p.children.length) {
          this.fetchChildPerm(p.children)
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
